import React from 'react';
import Modal from '../../components/Modals/Modal';
import WarningIcon from '../../components/Icons/outline/WarningIcon';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import RedButton from '../../components/Buttons/RedButton';
import { COLORS } from '../../config';

function DeleteClinicModal({
  showDeleteClinicModal,
  setShowDeleteClinicModal,
  onDelete,
}) {

  const handleHide = () => {
    setShowDeleteClinicModal(false)
  }

  const handleDelete = () => {
    onDelete();
    setShowDeleteClinicModal(false);
  }
  
  return (
    <Modal className='min-w-1/2' title={'Warning'} show={showDeleteClinicModal} hide={handleHide}>
      <div className='flex flex-col justify-between my-8'>
        <WarningIcon className='h-12 w-12 self-center mb-4 -mt-4' stroke={ COLORS.deleteRed } />
          <p className='mb-4'>
            Deleting this clinic will remove it from the platform. Removing it will remove it from all partners' clinic associations.
          </p>
          <p>
            This action will not be able to be reversed§. Are you sure you want to proceed?
          </p>
      </div>
      <div className='grid grid-cols-2 gap-x-2'>
        <SecondaryButton onClick={handleHide} text='Cancel'/>
        <RedButton text={'Delete clinic'} onClick={handleDelete} />
      </div>
    </Modal>
  )
}

export default DeleteClinicModal
